
import request from '@/utils/request'

export function getHostessIncomeDetail(data) {
  return request({
    url: '/agent_admin/data/income_detail',
    method: 'post',
    data,
  })
}
